import devConfig from "./app_config.json";
import { prodConfig } from "./app_config_prod.js";

const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;

export const API_BASE_URL = config.API_BASE_URL;
export const FRONTEND_URL = config.FRONTEND_URL;
